import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Dialog, DialogFooter, PrimaryButton, Link, Text } from '@fluentui/react';
import { getReviewModalDialogProps } from '@shared/utils/reviewsUtils';
import { Constants } from '@shared/utils/constants';
export const SubmitReviewResponseModal = ({ context, title, content, dialogIcon, shouldRenderLink, closeModal })=>{
    const dialogProps = getReviewModalDialogProps(title);
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: false,
        onDismiss: ()=>closeModal(),
        dialogContentProps: dialogProps.dialogContentProps,
        maxWidth: dialogProps.maxWidth,
        modalProps: dialogProps.modalProps,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "ResponeDialogContent",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        className: "ResponeDialogImg",
                        src: dialogIcon
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        className: "ResponeDialogText",
                        children: [
                            content,
                            ' ',
                            shouldRenderLink && /*#__PURE__*/ _jsx(Link, {
                                className: "ResponeDialogLink",
                                target: "_blank",
                                href: Constants.MicrosoftRatingReviewPolicy,
                                children: context.loc('SubmitReviewResponseModal_Policy', 'View review policies')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    onClick: ()=>closeModal(),
                    text: context.loc('Rating_SuccessButton', 'Done')
                })
            })
        ]
    });
};
